import { React, useEffect, useState } from 'react';
import './App.css';
import Products from './components/products';
import FilterBy from './components/filterBy';
import SortBy from './components/sortBy';
// The function that makes the fetch request to the Products API
import { getProducts } from './services/getProducts';
// filter and sort functions
import filterCategory from './services/filterCategory';
import sortProducts from './services/sortProducts';

function App() {
  // use the products variable to read all of your products
  // and display them on your page
  const [products, setProducts] = useState([]);
  const [filterBy, setFilterBy] = useState('All');
  const [sortBy, setSortBy] = useState('Latest');
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const products = await getProducts();
      setProducts(products);
    };
    loadData();
  }, []);

  useEffect(() => {
    const filtered = filterCategory(products, filterBy);
    const sorted = sortProducts(filtered, sortBy);
    setFilteredProducts([...sorted]);
  }, [filterBy, sortBy, products]);

  return (
    <div className='container'>
      <h1 className ='shop-title'>BIONIC BOUTIQUE</h1>
      <h2 className='shop-tagline'>We don't just give you a hand, we give you the whole arm.</h2>
      <div className='navbar'>
        <SortBy setSortBy={setSortBy} />
        <FilterBy setFilterBy={setFilterBy} />
      </div>
      <Products products={filteredProducts} />
    </div>
  );
}

export default App;
